<template>
  <v-dialog v-model="show" persistent max-width="850">
    <v-card>
      <v-card-title>Cask Notes</v-card-title>
      <v-divider/>
      <v-card-text class="pb-0 px-0 pt-2">
        <v-btn v-if="$vuetify.breakpoint.mobile && !readOnly && allowAdd" color="primary" outlined @click="showAddNotes=true" small class="ml-2 mt-2">Add note</v-btn>
        <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer fixedHeader height="250"
                      :items="cask.notes" no-data-text="No cask notes"
                      :headers="headers" class="no-sort">
          <template v-slot:header.add v-if="!$vuetify.breakpoint.mobile && allowAdd">
            <v-btn fab color="primary" x-small @click="showAddNotes=true;">
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.add="{item}">
            <v-btn class="mt-n2" icon @click.stop="noteId = item.id;showDelete=true"><v-icon small>mdi-delete</v-icon></v-btn>
          </template>
          <template v-slot:item.date="{value}">
            {{value | formatDateTime}}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn color="primary" @click="close()">Done</v-btn>
      </v-card-actions>
    </v-card>

    <inventory-casks-notes-add v-model="showAddNotes" :cask="cask" @noteAdded="noteAdded($event)"/>
    <delete-object v-model="showDelete" name="this note" @delete="deleteNote"/>
  </v-dialog>
</template>

<script>
import InventoryCasksNotesAdd from '@/views/inventory/casks/InventoryCasksNotesAdd'

export default {
  name: 'InventoryCasksNotes',
  components: {InventoryCasksNotesAdd},
  props: {
    value: {type:Boolean, required:true},
    caskId: {type:String, required:false},
    hasNotes: {type:Boolean, required:false},
    allowAdd: {type:Boolean, required:false, default:true}
  },
  data () {
    return {
      show: false,
      loading: false,
      cask: {},
      showAddNotes: false,
      showDelete: false,
      noteId: null
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('inventory.write');
    },
    headers() {
      const headers = [{text:'Date',value:'date',width:'20%'},
                        {text:'Note',value:'comments',width:'35%'}];
      if (!this.readOnly && this.allowAdd)
        return [{text:'',value:'add',width:'5%',align:'center',cellClass:'pa-0'}, ...headers];
      return headers;
    }
  },
  watch: {
    async value() {
      if (this.value) {
        this.loading = true;
        const results = await this.$apiCall(`query InventoryCasksNotes($id:ID!) {
                                                  cask(id:$id) {
                                                    id,notes{id,date,comments}
                                                  }
                                                }`,
                                            {id:this.caskId});
        if (!results.error)
          this.cask = results.data.cask;
        this.loading = false;
      }

      this.show = this.value;
    }
  },
  methods: {
    async deleteNote() {
      const results = await this.$apiCall(`mutation InventoryCasksNotes($id:ID!, $noteId:ID!) {
                                              caskNoteDelete(id:$id, noteId:$noteId)
                                            }`,
                                        {id:this.caskId,noteId:this.noteId});
      if (!results.error) {
        const index = this.cask.notes.findIndex(n => n.id === this.noteId);
        this.cask.notes.splice(index, 1);
        this.$emit('update:hasNotes', results.data.caskNoteDelete);
      }
    },
    noteAdded(note) {
      this.cask.notes.push(note);
      this.$emit('update:hasNotes', true);
    },
    close() {
      this.$emit('input', false);
    }
  }
}
</script>